import {SET_NAVIGATION_OPENED, SET_NAVIGATION_CLOSED} from '@/store/mutation-types'

const state = {
	navigationState: localStorage.getItem('navigationState') || 'opened'
}

const getters = {
	isNavigationOpened: (state) => {
		return state.navigationState === 'opened'
	}
}

const actions = {
	[SET_NAVIGATION_OPENED]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SET_NAVIGATION_OPENED, data)
			resolve()
		})
	},
	[SET_NAVIGATION_CLOSED]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SET_NAVIGATION_CLOSED, data)
			resolve()
		})
	}
}

const mutations = {
	[SET_NAVIGATION_OPENED]: () => {
		state.navigationState = 'opened'
		localStorage.setItem('navigationState', 'opened')
	},
	[SET_NAVIGATION_CLOSED]: () => {
		state.navigationState = 'closed'
		localStorage.setItem('navigationState', 'closed')
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js